<template>
  <div class="CorporationM">
    <PageContent>
      <StepsV2 type="s4" :step="3" />
      <PanelV2
        type="w6"
        title="You need to open a BDO or BDO Network Bank Account"
        @nextClick="commitData"
      >
        <template v-slot:content-solt>
          <BdoNoAccount />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  import BdoNoAccount from "./common/BdoNoAccount";
  export default {
    name: 'SolePropN',
    components: {
      BdoNoAccount,
    },
    data() {
      return {
      }
    },
    methods: {
      commitData() {
        this.$router.push({name: 'SolePropJ'})
      }
    }
  }
</script>


<style lang="scss">
.el-form.NewMerchantCorpH {
  .el-form-item:nth-child(4) {
    margin-top: -120px;
  }
}
</style>
